import { useState } from 'react';
import Seo from '../../components/Seo';
import { Field, Spinner } from '../../components/ui';
import { changePassword } from '../../api/auth';
import { useToast } from '../../context/ToastContext';

export default function ChangePassword() {
  const toast = useToast();
  const [form, setForm] = useState({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErrors({});
    setSaving(true);
    try {
      await changePassword(form);
      toast.success('Password changed successfully.');
      setForm({ current_password: '', password: '', password_confirmation: '' });
    } catch (err) {
      setErrors(err.errors || {});
      toast.error(err.message || 'Could not change password.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-lg space-y-6">
      <Seo title="Change Password" />
      <h1 className="font-display text-2xl font-bold">Change Password</h1>

      <form onSubmit={handleSubmit} className="card space-y-5 p-6">
        <Field label="Current password" error={errors.current_password?.[0]}>
          <input
            type="password"
            className="input"
            autoComplete="current-password"
            value={form.current_password}
            onChange={(e) => setForm({ ...form, current_password: e.target.value })}
            required
          />
        </Field>
        <Field label="New password" error={errors.password?.[0]}>
          <input
            type="password"
            className="input"
            autoComplete="new-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
        </Field>
        <Field label="Confirm new password">
          <input
            type="password"
            className="input"
            autoComplete="new-password"
            value={form.password_confirmation}
            onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
            required
          />
        </Field>
        <button type="submit" className="btn-primary w-full" disabled={saving}>
          {saving ? <Spinner className="h-4 w-4 text-white" /> : 'Update password'}
        </button>
      </form>
    </div>
  );
}
